import InputSelect from "@/components/input-select/InputSelect";
import ScanCode from "@/pages/capture/components/ScanCode";
import { literals } from "@/constants/literals";
import { GARAGE_STEPS, GARAGES } from "@/constants/selectsLists";
import type { IGarage } from "@/types/types.d";

export interface CommonGaragesInputsProps {
  changeCommonGarageData: <KeyName extends keyof IGarage>(
    id: KeyName,
    value: IGarage[KeyName],
  ) => void;
  commonGarageData: IGarage;
}

const CommonGaragesInputs = ({
  changeCommonGarageData,
  commonGarageData,
}: CommonGaragesInputsProps) => {
  return (
    <>
      <div className="w-full mb-4 md:w-[calc(50%-16px)]">
        <InputSelect
          size="medium"
          label={literals.garage}
          id="garage"
          name="garage"
          options={GARAGES}
          onChange={(new_value) => changeCommonGarageData("garage", new_value)}
          value={commonGarageData.garage}
          required
          placeholder={literals.chooseAnOption}
        />
      </div>
      <div className="w-full mb-4 md:w-[calc(50%-16px)]">
        <InputSelect
          size="medium"
          label={literals.step}
          id="step"
          name="step"
          options={GARAGE_STEPS}
          onChange={(new_value) => changeCommonGarageData("step", new_value)}
          value={commonGarageData.step}
          required
          placeholder={literals.chooseAnOption}
        />
      </div>
      <div className="w-full md:w-[calc(50%-16px)]">
        <ScanCode
          value={commonGarageData.orderNumber}
          onChange={(new_value) =>
            changeCommonGarageData("orderNumber", new_value)
          }
          codeType="sapOrder"
        />
      </div>
    </>
  );
};

export default CommonGaragesInputs;
